import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import Http from "../../Http/Http";
import Log from "../../Log/Log";

export default function* pontoIntegrationGet(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "ponto-integration");
    const raw = res.data?.data;
    const pontoIntegration = raw
      ? {
          id: raw.id,
          agencyId: raw.agencyId,
          companyId: raw.companyId,
          status: raw.status,
          bankAccounts: raw.bankAccounts ? raw.bankAccounts : [],
        }
      : null;

    yield put({
      type: Constants.GLOBAL_PONTO_INTEGRATION_GET_SUCCESS,
      payload: { pontoIntegration },
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, pontoIntegration);
    }
  } catch (err) {
    Log.warn("PontoIntegrationGet failed; treating as no active integration", {
      message: err && err.message,
      status: err && err.response ? err.response.status : null,
    });
    yield put({
      type: Constants.GLOBAL_PONTO_INTEGRATION_GET_SUCCESS,
      payload: { pontoIntegration: null },
    });
  }
}

export function* watchPontoIntegrationGet() {
  yield takeEvery(Constants.GLOBAL_PONTO_INTEGRATION_GET, pontoIntegrationGet);
}
